// checkMaintenance.ts

import { redis } from "./redis";

interface CheckMaintenanceProps {
    env: "prod" | "dev";
}
export async function checkMaintenance({ env }: CheckMaintenanceProps) {
    const maintenance = await redis.mget(`eh:maintenance:${env}`);
    console.log("maintenance", maintenance);
    if (maintenance[0]) {
        const timestamp =
            typeof maintenance[0] === "string"
                ? Number(maintenance[0])
                : maintenance[0];
        if (!isNaN(timestamp) && typeof timestamp === "number") {
            // return timestamp > Date.now();
            if (timestamp > Date.now()) {
                return timestamp;
            } else {
                return null;
            }
        }
    }
    return null;
}
